import variables from '../variables';
/* eslint-disable */
const MuiTooltip = {
  tooltip: {
    marginTop: 15,
    fontSize: 16,
    fontWeight: 400,
    padding: 30,
    boxShadow: `0 0 8px 0 ${variables.colors.backgroundDark}`,
    backgroundColor: variables.colors.backgroundHighlight,
    color: variables.colors.tan,
  },
};

export default MuiTooltip;
